// FAQSection.jsx
import React from 'react';
import { Container, Accordion } from 'react-bootstrap';
import styles from './../style/FAQSection.module.scss';

const FAQSection = ({ qwestions }) => {

  return (
    <section className={styles.faqSection}>
      <Container className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Часто задаваемые вопросы</h2>
        </div>
        
        <Accordion defaultActiveKey="0" className={styles.faqAccordion}>
          {qwestions.map((item, index) => (
            <Accordion.Item key={index} eventKey={index.toString()} className={styles.accordionItem}>
              <Accordion.Header className={styles.accordionHeader}>
                <span className={styles.accordionTitle}>{item.name}</span>
              </Accordion.Header>
              <Accordion.Body className={styles.accordionBody} dangerouslySetInnerHTML={{__html: item.text}} />
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
};

export default FAQSection;